import { Injectable } from '@angular/core';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { AfterClose, CloseTabSuccess, OnClose, OnConfirmBeforeClose, OnSave, TabModel } from 'shared';
import { UUID } from 'symbols';

@Injectable()
export class TabsEventManagerService {
  private onConfirmBeforeCloseListeners: OnConfirmBeforeClose[] = [];
  private onCloseListeners: OnClose[] = [];
  private onSaveListeners: OnSave[] = [];
  private afterCloseListeners: AfterClose[] = [];


  constructor(private actions$: Actions) {
    this.actions$.pipe(ofActionDispatched(CloseTabSuccess))
      .subscribe(action => {
        this.afterClose(action.tab.id);
      });
  }

  registration(listener: any, tabUUID? : string) {
    const id = tabUUID || listener.route.snapshot.data['tabUUID'];
    if (!id) {
      throw new Error('Listener does not have listenerId!');
    }

    this.onConfirmBeforeCloseListeners = this.onConfirmBeforeCloseListeners.filter(l => l.listenerUUID !== id);
    this.onCloseListeners = this.onCloseListeners.filter(l => l.listenerUUID !== id);
    this.onSaveListeners = this.onSaveListeners.filter(l => l.listenerUUID !== id);
    this.afterCloseListeners = this.afterCloseListeners.filter(l => l.listenerUUID !== id);

    listener.listenerUUID = id;
    if (isOnConfirmBeforeClose(listener)) {
      this.onConfirmBeforeCloseListeners.push(listener);
    }
    if (isOnClose(listener)) {
      this.onCloseListeners.push(listener);
    }
    if (isOnSave(listener)) {
      this.onSaveListeners.push(listener);
    }
    if (isAfterClose(listener)) {
      this.afterCloseListeners.push(listener);
    }
  }


  onCloseConfirm(tab: TabModel) {
    this.onConfirmBeforeCloseListeners.forEach(listener => listener.onConfirmBeforeClose(tab));
  }

  onClose(tab: TabModel) {
    this.onCloseListeners.forEach(listener => listener.onClose(tab));
  }

  onSave(tab: TabModel, force: boolean = false) {
    this.onSaveListeners.forEach(listener => listener.onSave(tab, force));
  }

  afterClose(docId: UUID) {
    this.afterCloseListeners.forEach(listener => listener.afterClose(docId));
  }
}

function isOnConfirmBeforeClose(obj: any): obj is OnConfirmBeforeClose {
  return typeof obj?.onConfirmBeforeClose === 'function';
}

function isOnClose(obj: any): obj is OnClose {
  return typeof obj?.onClose === 'function';
}

function isOnSave(obj: any): obj is OnSave {
  return typeof obj?.onSave === 'function';
}

function isAfterClose(obj: any): obj is AfterClose {
  return typeof obj?.afterClose === 'function';
}
